<script setup lang="ts">
import { CommonButton } from '#components'
import { useTheme } from "~/composables/useTheme";
const { colors, themeName } = useTheme();
</script>

<template>
  <section>
    <div class="book-a-call-box" :style="{ backgroundColor: colors.primary, color: colors.text }">
      <h3 :style="{ color: colors.primaryText }">Still have a question?</h3>
      <h3 :style="{ color: colors.primaryText }" class="text-center">Book a quick call with our support team</h3>
      <CommonButton :aria-label="'Book a call(Opens in a new tab)'" text="Book a call" :color="colors.buttonBg"
        width="150px" height="40px" :href="'https://calendly.com/neha-equirize/30min'" target="_blank" />
    </div>
  </section>
</template>

<style scoped>
.book-a-call-box {
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1%;
  border-radius: 10px;
  padding: 2rem;
}
</style>